/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ParamedicReferralCharge from './paramedic-referral-charge';
import ParamedicReferralChargeDetail from './paramedic-referral-charge-detail';
import ParamedicReferralChargeUpdate from './paramedic-referral-charge-update';
import ParamedicReferralChargeDeleteDialog from './paramedic-referral-charge-delete-dialog';

const ParamedicReferralChargeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ParamedicReferralCharge />} />
    <Route path="new" element={<ParamedicReferralChargeUpdate />} />
    <Route path=":id">
      <Route index element={<ParamedicReferralChargeDetail />} />
      <Route path="edit" element={<ParamedicReferralChargeUpdate />} />
      <Route path="delete" element={<ParamedicReferralChargeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ParamedicReferralChargeRoutes;
